export default __webpack_public_path__ + "static/media/rakhi8.fe2a7c7b.jpeg";